<template>
  <div ref="pageView" class="all-content container-view" v-loading="loading">
    <!-- title start -->
    <section class="title clearfix fixed-view">
      <div class="title-name fl">门店监控</div>
      <div class="oprate">
        <el-checkbox v-model="checked" @change="autoRefreshEvent"
          >自动刷新
        </el-checkbox>
        <i class="e6-icon-refresh_line" @click="getInitData"></i>
        <span class="refresh-icon" @click="getInitData">手动刷新</span>
        <i
          class="search-icon e6-icon-search_line"
          @click="handleSearchFormVisible"
        ></i>
      </div>
    </section>
    <!-- title end -->
    <!-- 查询条件 start -->
    <section class="search fixed-view" v-show="searchFormVisible">
      <el-form class="searchForm" ref="searchForm" :model="searchForm">
        <el-form-item class="search-item fl" prop="comparyIdList">
          <el-select
            v-model="searchForm.comparyIdList"
            placeholder="企业名称"
            filterable
            multiple
            collapse-tags
            clearable
            class="select-limit"
          >
            <el-option
              v-for="item in allComparys"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search-item fl" prop="storeName">
          <el-input
            v-model="searchForm.storeName"
            placeholder="门店名称"
          ></el-input>
        </el-form-item>
        <el-form-item class="search-item fl" prop="countyNameId">
          <!--<dict-select-->
          <!--v-model="searchForm.countyNameId"-->
          <!--placeholder="所属区(县)"-->
          <!--:pkey="'county_name'"-->
          <!--&gt;</dict-select>-->
          <e6-city
            ref="e6City"
            :placeholder="$GLOBAL_CONFIG.e6City.placeholder"
            class="e6-city"
            @selected="citySelect"
          ></e6-city>
        </el-form-item>
        <el-form-item class="search-item fl">
          <el-button type="primary" @click="handleQuery()">查询</el-button>
        </el-form-item>
        <el-form-item class="search-item fl">
          <el-button type="primary" plain @click="handleReset">
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </section>
    <!-- 查询条件 end -->
    <!-- 状态筛选操作按钮 start -->
    <div class="info-row fixed-view clearfix">
      <el-radio-group v-model="chooseStatus" @change="selectStatus">
        <el-radio-button class="status-btn" label="0">全部</el-radio-button>
        <el-radio-button class="status-btn" label="1">正常</el-radio-button>
        <el-radio-button class="status-btn" label="2">报警</el-radio-button>
        <el-radio-button class="status-btn" label="3">掉线</el-radio-button>
      </el-radio-group>
      <span class="all-msg"
        >共{{ comparyAllCount }}家企业，{{ storeAllCount }}个门店，{{
          areaAllCount
        }}个冷柜，{{ labelAllCount }}个监测点</span
      >
      <div class="show-all fr" @click="handleIsAllShow">
        {{ isAllShow }}
        <i class="el-icon-arrow-down" v-show="openningList.length"></i>
        <i class="el-icon-arrow-right" v-show="!openningList.length"></i>
      </div>
    </div>
    <!-- 状态筛选操作按钮 end -->
    <!-- 主体内容 start -->
    <div class="content">
      <div
        class="all-info-wrapper"
        element-loading-text="数据加载中"
        :style="`height: ${resizeViewHeight - 20 - 28 - 50 - searchHeight}px`"
        ref="company"
      >
        <!-- 动态加载公司 -->
        <div class="company" v-for="corp in comparyList" :key="corp.comparyId">
          <div
            class="company-title clearfix"
            @click.self="isShowCompary(corp.comparyId)"
          >
            <div class="company-title-info fl">
              <i class="company-icon"></i>
              <span class="company-name">{{ corp.comparyName }}</span>
            </div>
            <div class="show-icon fr">
              <i
                class="el-icon-arrow-down"
                @click.self="isShowCompary(corp.comparyId)"
                v-show="isOpenning('corp-' + corp.comparyId)"
              ></i>
              <i
                class="el-icon-arrow-right"
                @click.self="isShowCompary(corp.comparyId)"
                v-show="!isOpenning('corp-' + corp.comparyId)"
              ></i>
            </div>
          </div>
          <!-- 门店列表 -->
          <div class="storage-list-wrapper clearfix">
            <!-- 门店 -->
            <div
              v-show="isOpenning('corp-' + corp.comparyId)"
              class="storage clearfix"
              v-for="store in corp.storeList"
              :key="store.storeId"
            >
              <div
                class="storage-title clearfix"
                @click.self="isShowStore(store.storeId)"
              >
                <div class="title-info fl">
                  <i class="e6-icon-store_fill storage-icon"></i>
                  <span class="storage-name">{{ store.storeName }}</span>
                </div>
                <!-- 仓库条右边状态统计 -->
                <div class="tag-group fr">
                  <span class="tag-group__title"
                    >{{ store.freezerCountAll }}个冷柜</span
                  >
                  <el-tag
                    class="tag-item"
                    v-bind:class="{
                      iszero: isZeroNormal(store.freezerCountNormal)
                    }"
                  >
                    <span class="tag-color alarm-0"></span>
                    <span class="tag-font">正常</span>
                    <span class="tag-font">{{ store.freezerCountNormal }}</span>
                  </el-tag>
                  <el-tag
                    class="tag-item"
                    v-bind:class="{
                      iszero: isZeroAlarm(store.freezerCountAlarm)
                    }"
                  >
                    <span class="tag-color alarm-2"></span>
                    <span class="tag-font">报警</span>
                    <span class="tag-font">{{ store.freezerCountAlarm }}</span>
                  </el-tag>
                  <el-tag
                    class="tag-item"
                    v-bind:class="{
                      iszero: isZeroDropLine(store.freezerCountDropLine)
                    }"
                  >
                    <span class="tag-color alarm-3"></span>
                    <span class="tag-font">掉线</span>
                    <span class="tag-font">{{
                      store.freezerCountDropLine
                    }}</span>
                  </el-tag>
                  <i
                    class="el-icon-arrow-right"
                    v-show="!isOpenning('store-' + store.storeId)"
                    @click.self="isShowStore(store.storeId)"
                  ></i>
                  <i
                    class="el-icon-arrow-down"
                    v-show="isOpenning('store-' + store.storeId)"
                    @click.self="isShowStore(store.storeId)"
                  ></i>
                </div>
              </div>
              <!-- 区位列表 -->
              <div
                class="area-list-wrapper clearfix"
                v-show="isOpenning('store-' + store.storeId)"
              >
                <!-- 区位 -->
                <template v-for="area in store.freezerList">
                  <div
                    class="label-list fl"
                    v-for="(label, index) in area.freezerLabelList"
                    :key="`${label.labelId}-${label.channelNum}`"
                  >
                    <!-- 只给每个区位下的第一个监测点加区位名 start-->
                    <div
                      v-if="!index"
                      class="area-name"
                      :title="area.freezerName"
                      :class="getAreaClassName(area)"
                    >
                      {{ area.freezerName }}
                    </div>
                    <!--监测点加区位名 end -->
                    <el-card class="box-card" :class="'status-' + label.status">
                      <div slot="header" class="clearfix">
                        <div class="item-name-box fl">
                          <span
                            class="area-item-name"
                            :title="label.labelName"
                            >{{ label.labelName }}</span
                          >
                        </div>
                        <div class="item-time-box fr">
                          <span
                            class="area-item-time"
                            v-if="label.time != '1900-01-01'"
                            >{{ label.time }}</span
                          >
                        </div>
                      </div>
                      <div class="card-body">
                        <div v-if="label.status === 3">
                          <div class="nodata">读取不到最新数据</div>
                        </div>
                        <div v-if="label.status !== 3">
                          <div class="card-tehu clearfix">
                            <div
                              class="tehu-box fl"
                              :class="isRedTem(label.alarmTypeStr)"
                            >
                              <!-- -999代表无效 用--代替 -->
                              <span
                                class="tehu"
                                v-if="
                                  label.temperature > 99 ||
                                    label.temperature < -99
                                "
                                >--
                              </span>
                              <span class="tehu" v-else
                                >{{ label.temperature.toFixed(1) }}
                              </span>
                              <span>℃</span>
                              <i
                                class="arrow"
                                :class="getLabelTemArrow(label.alarmTypeStr)"
                                v-if="
                                  label.temperature <= 99 &&
                                    label.temperature >= -99
                                "
                              ></i>
                            </div>
                            <div
                              class="tehu-box fl"
                              :class="isRedHum(label.alarmTypeStr)"
                            >
                              <span
                                class="tehu"
                                v-if="
                                  label.humidity > 99 || label.humidity < -99
                                "
                                >--
                              </span>
                              <span class="tehu hum" v-else
                                >{{ label.humidity }}
                              </span>
                              <span>%RH</span>
                              <i
                                class="arrow"
                                :class="getLabelHumArrow(label.alarmTypeStr)"
                                v-if="
                                  label.humidity <= 99 && label.humidity >= -99
                                "
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-card>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="nomore" v-if="this.comparyList.length">
          <span>已加载全部门店</span>
        </div>
        <div class="nomore" v-if="!this.comparyList.length">
          <span>暂无数据</span>
        </div> -->
      </div>
      <!-- 翻页 -->
      <section class="pagination-section">
        <e6-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :pageSize.sync="pageSize"
          :pageSizes="[10, 20]"
          :currentPage.sync="curPage"
          @currentChange="handleCurrentChange"
          @sizeChange="handleSizeChange"
        ></e6-pagination>
      </section>
      <!-- 翻页 end -->
    </div>
    <!-- 主体内容 end -->
  </div>
</template>
<script>
import resizeListener from "_private/mixins/resizeListener";
import { FetchStoreListByPage } from "../../../api/monitorCenter/storageList";
import { FetchAllComparys } from "_private/api/systemSetting/userManage";
import e6City from "e6city";
export default {
  mixins: [resizeListener],
  components: { e6City },
  data() {
    return {
      loading: false,
      isAllShow: "全部收起",
      chooseStatus: "0", //切换状态按钮
      isAllShowStatus: true, //全部展开/收起状态
      autoRefresh: false, //自动刷新是否勾选
      checked: false,
      timeOut: "", //自动刷新定时器
      searchFormVisible: false, //查询条件是否展开
      searchForm: {
        comparyName: "", //企业名称
        // provinceName:$GLOBAL_CONFIG.e6City.provinceName,
        provinceName: "",
        // cityName:$GLOBAL_CONFIG.e6City.cityName,
        cityName: "",
        countyName: "",
        status: 0, //监控的报警状态
        comparyIdList: [],
        storeName: ""
      },
      searchHeight: 0,
      curPage: 1,
      total: 0,
      pageSize: 10,
      comparyList: [], // 当前展示的数据
      allComparyList: [], // 所有数据源
      openningList: [], //展开状态的企业、仓库id
      allComparys: [] //所有企业名称
    };
  },
  computed: {
    //企业总数
    comparyAllCount() {
      let comparyNum = this.comparyList.length;
      return comparyNum;
    },
    //门店总数
    storeAllCount() {
      let storeNum = 0;
      this.comparyList.forEach(item => {
        storeNum += item.storeList.length;
      });
      return storeNum;
    },
    //区位总数
    areaAllCount() {
      let areaNum = 0;
      this.comparyList.forEach(item => {
        item.storeList.forEach(area => {
          areaNum += area.freezerList.length;
        });
      });
      return areaNum;
    },
    //监测点总数
    labelAllCount() {
      let labelNum = 0;
      this.comparyList.forEach(item => {
        item.storeList.forEach(area => {
          area.freezerList.forEach(label => {
            labelNum += label.freezerLabelList.length;
          });
        });
      });
      return labelNum;
    }
  },
  created() {
    this.initAllComparys();
    if (this.$route.query.companyId && this.$route.query.status) {
      this.searchForm.comparyIdList.push(parseInt(this.$route.query.companyId));
      this.searchForm.status = this.$route.query.status;
      this.chooseStatus = this.$route.query.status;
    }

    if (this.timeOut) {
      clearTimeout(this.timeOut);
    }
    this.getInitData();
    //监听数据
    this.getListIng();
  },
  destroyed: function() {
    clearTimeout(this.timeOut);
    this.timeOut = "";
  },
  methods: {
    // 分页
    getCurPageIndex() {
      let startIndex = this.pageSize * (this.curPage - 1);
      let lastIndex = this.pageSize * this.curPage;
      return [startIndex, lastIndex];
    },
    //获取数据
    getInitData() {
      this.loading = true;
      FetchStoreListByPage(this.searchForm)
        .then(res => {
          let comparyList = [];
          this.openningList = [];
          if (res.code === 1 && Array.isArray(res.result.comparyList)) {
            comparyList = res.result.comparyList;
          }
          this.allComparyList = comparyList;
          this.total = this.allComparyList.length;
          this.showCurpageData();
          this.handleIsAllShow(true);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 组装当页数据
    showCurpageData() {
      this.comparyList = [];
      let dataIndexArr = this.getCurPageIndex();
      this.comparyList = this.allComparyList.filter((v, i) => {
        return i >= dataIndexArr[0] && i < dataIndexArr[1];
      });

      this.comparyList.forEach(compary => {
        this.openningList.push("corp-" + compary.comparyId);
        compary.storeList.forEach(store => {
          this.openningList.push("store-" + store.storeId);
        });
      });
    },
    //企业是否展开
    isShowCompary(id) {
      let idStr = "corp-" + id;
      if (this.openningList.includes(idStr)) {
        this.openningList.splice(
          this.openningList.findIndex(item => item === idStr),
          1
        );
      } else {
        this.openningList.push(idStr);
      }
    },
    //仓库是否展开
    isShowStore(id) {
      let idStr = "store-" + id;
      if (this.openningList.includes(idStr)) {
        this.openningList.splice(
          this.openningList.findIndex(item => item === idStr),
          1
        );
      } else {
        this.openningList.push(idStr);
      }
    },
    //控制展开收起
    isOpenning(itemStr) {
      return this.openningList.includes(itemStr);
    },
    //全部展开&全部收起状态切换
    handleIsAllShow(type) {
      if (type === true) {
        this.isAllShowStatus = type;
      } else {
        this.isAllShowStatus = !this.isAllShowStatus;
      }
      if (this.isAllShowStatus) {
        this.isAllShow = "全部收起";
        this.comparyList.forEach(compary => {
          let comStr = "corp-" + compary.comparyId;
          if (!this.openningList.includes(comStr)) {
            this.openningList.push(comStr);
          }
          compary.storeList.forEach(store => {
            let storeStr = "store-" + store.storeId;
            if (!this.openningList.includes(storeStr)) {
              this.openningList.push(storeStr);
            }
          });
        });
      } else {
        this.isAllShow = "全部展开";
        this.openningList = [];
      }
    },
    //状态按钮改变事件
    selectStatus(val) {
      this.searchForm.status = +val; //字符串转数字
      this.getInitData();
    },
    //监听数据
    getListIng() {
      let _this = this;
      //判断是否自动刷新数据
      if (this.autoRefresh) {
        this.getInitData(); //请求的函数
        this.timeOut = setTimeout(() => {
          _this.getListIng();
        }, 30000);
      }
    },
    //自动刷新
    autoRefreshEvent(checked) {
      this.autoRefresh = checked;
      if (checked) {
        //监听数据
        this.getListIng();
      } else {
        //清空定时器
        clearTimeout(this.timeOut);
        this.timeOut = "";
      }
    },
    //查询条件显示隐藏
    handleSearchFormVisible() {
      this.searchFormVisible = !this.searchFormVisible;
      this.searchFormVisible
        ? (this.searchHeight = 60)
        : (this.searchHeight = 0);
    },
    //查询
    handleQuery(val) {
      if (val) {
        this.searchForm.status = val;
      }
      this.getInitData();
    },
    //重置
    handleReset() {
      this.$refs["searchForm"].resetFields();
      this.$refs["e6City"].clearCity();
      this.searchForm.provinceName = "";
      this.searchForm.cityName = "";
      this.searchForm.countyName = "";
      this.$refs.e6City.clearCity();
    },
    //区位名 颜色类名
    getAreaClassName(area) {
      let status = [];
      area.freezerLabelList.forEach(label => {
        status.push(label.status);
      });
      if (status.includes(2)) {
        return "alarm-2";
      } else if (status.includes(3)) {
        return "alarm-3";
      } else {
        return "alarm-0";
      }
    },
    // 区位状态数为0的置灰
    isZeroNormal(val) {
      let status = val === 0 ? true : false;
      return status;
    },
    isZeroAlarm(val) {
      let status = val === 0 ? true : false;
      return status;
    },
    isZeroDropLine(val) {
      let status = val === 0 ? true : false;
      return status;
    },
    //温度报警箭头
    getLabelTemArrow(alarmStr) {
      if (alarmStr.includes("1-1-1")) {
        return "e6-icon-grade-_fill2";
      }
      if (alarmStr.includes("1-1-2")) {
        return "e6-icon-grade-_fill1";
      }
      if (alarmStr.includes("1-1-3")) {
        return "e6-icon-grade-_fill";
      }
      if (alarmStr.includes("1-2-1")) {
        return "e6-icon-grade-_fill2 irotate";
      }
      if (alarmStr.includes("1-2-2")) {
        return "e6-icon-grade-_fill1 irotate";
      }
      if (alarmStr.includes("1-2-3")) {
        return "e6-icon-grade-_fill irotate";
      }
    },
    //湿度报警箭头
    getLabelHumArrow(alarmStr) {
      if (alarmStr.includes("2-1-1")) {
        return "e6-icon-grade-_fill2";
      }
      if (alarmStr.includes("2-1-2")) {
        return "e6-icon-grade-_fill1";
      }
      if (alarmStr.includes("2-1-3")) {
        return "e6-icon-grade-_fill";
      }
      if (alarmStr.includes("2-2-1")) {
        return "e6-icon-grade-_fill2 irotate";
      }
      if (alarmStr.includes("2-2-2")) {
        return "e6-icon-grade-_fill1 irotate";
      }
      if (alarmStr.includes("2-2-3")) {
        return "e6-icon-grade-_fill irotate";
      }
    },
    //温度字体颜色
    isRedTem(alarmStr) {
      if (alarmStr.includes("1-1-") || alarmStr.includes("1-2-")) {
        return "isred2";
      } else {
        return "isred0";
      }
    },
    //湿度字体颜色
    isRedHum(alarmStr) {
      if (alarmStr.includes("2-1-") || alarmStr.includes("2-2-")) {
        return "isred2";
      } else {
        return "isred0";
      }
    },
    /**
     *  初始化企业
     */
    initAllComparys() {
      FetchAllComparys()
        .then(response => {
          if (
            response.result &&
            response.result &&
            Array.isArray(response.result)
          ) {
            this.allComparys = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    citySelect(res) {
      if (
        res.province.name == "澳门" ||
        res.province.name == "香港" ||
        res.province.name == "台湾省"
      ) {
        this.searchForm.provinceName = res.province.name;
        this.searchForm.cityName = res.province.name;
      } else {
        this.searchForm.provinceName = res.province.name;
        this.searchForm.cityName = res.city.name;
        this.searchForm.countyName = res.district.name;
      }
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.showCurpageData();
      this.handleIsAllShow(true);
      this.$refs.company.scrollTop = 0; //滚动条回到顶部
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.curPage = 1;
      this.pageSize = e;
      this.getInitData();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/storage.scss";
@import "../../../assets/iconFont/iconfont.css";
</style>
